import AccountCircleIcon from '@material-design-icons/svg/outlined/account_circle.svg?react';
import ArrowDropDownIcon from '@material-design-icons/svg/outlined/arrow_drop_down.svg?react';
import LogOutIcon from '@material-design-icons/svg/outlined/logout.svg?react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { twMerge } from 'tailwind-merge';

import { AuthStateType, useAuth } from '../../hooks/useAuth';

import { Item } from './Item';

interface Props {
  className?: string;
}

export function HeaderUserDropdown({ className }: Props) {
  const [auth, { signOut }] = useAuth();

  if (auth.type !== AuthStateType.Authenticated) {
    return <div className={className} />;
  }

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          className={twMerge(
            'fill-white',
            'gap-x-1',
            'grid-cols-[max-content_1fr_max-content]',
            'grid',
            'group',
            'h-12',
            'items-center',
            'max-w-72',
            'outline-none',
            'px-2',
            'rounded-lg',
            'text-white',
            'transition-colors',
            'active:bg-black/20',
            'focus:bg-black/10',
            'hover:bg-black/10',
          )}
        >
          <AccountCircleIcon className="size-4" />
          <div className="truncate text-sm">{auth.user.fullName}</div>
          <ArrowDropDownIcon
            className={twMerge(
              'group-data-[state=open]:-rotate-180',
              'h-6',
              'ml-1',
              'transition-transform',
              'w-6',
            )}
          />
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content
        className="bg-white p-2 rounded-lg text-sm text-black w-60"
        sideOffset={4}
      >
        <DropdownMenu.Arrow className="fill-white" />
        <div className="p-1 truncate">{auth.user.email}</div>
        <div className="my-2 px-1">
          <DropdownMenu.Separator className="border-t border-neutral-200 w-full" />
        </div>
        <Item onClick={signOut}>
          <LogOutIcon className="size-4" />
          <div>Log out</div>
        </Item>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}
